<template>
    <div id="app" class="o-content ie">
        <div class="flex-state-buttons">
            <div class="u-d-flex">
                <h1 class="u-margin-top-10">
                    Market Analysis
                </h1>
            </div>
        </div>

        <p class="p-executive-dashboard__summary u-margin-bottom-20">
            The Market Analysis Dashboard will be ready soon...<br><br>
        </p>
    </div>
</template>

<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'market-analysis'
    }
</script>



// WEBPACK FOOTER //
// MarketAnalysis.vue?27286f7e